// add lazy-load supported
import LazyLoad from "vanilla-lazyload";

let myLazyLoad = new LazyLoad();

// to top
function scrollTo(to, duration = 700) {
    const
        element = document.scrollingElement || document.documentElement,
        start = element.scrollTop,
        change = to - start,
        startDate = +new Date(),
        // t = current time
        // b = start value
        // c = change in value
        // d = duration
        easeInOutQuad = function (t, b, c, d) {
            t /= d / 2;
            if (t < 1) return c / 2 * t * t + b;
            t--;
            return -c / 2 * (t * (t - 2) - 1) + b;
        },
        animateScroll = function () {
            const currentDate = +new Date();
            const currentTime = currentDate - startDate;
            element.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, duration));
            if (currentTime < duration) {
                requestAnimationFrame(animateScroll);
            } else {
                element.scrollTop = to;
            }
        };
    animateScroll();
}
document.addEventListener('DOMContentLoaded', function () {
    let btn = document.querySelector('#toTop');
    if (btn) {
        window.addEventListener('scroll', function () {
            // show if > 599px
            if (pageYOffset > 100) {
                btn.classList.add('show');
                // remove
            } else {
                btn.classList.remove('show');
            }
        });

        // to top on click
        btn.onclick = function (click) {
            click.preventDefault();
            scrollTo(0, 400);
        }
    }
});

// mobile burger menu
let body_class = document.body;
let burger = document.querySelector('.burger');
let menu_body = document.querySelector('.top_menu');
let menu_parent = document.querySelector('.header__bottom_string');
if (burger) {
    burger.onclick = function () {
        body_class.classList.toggle('menu-open');
        menu_body.classList.toggle('active');
        burger.classList.toggle('active')
        menu_parent.classList.toggle('active')
    }
}

// adaptive table class
function coverTable() {
    let table = document.querySelectorAll('table');
    for (let i = table.length - 1; i >= 0; i--) {
        let cover = document.createElement('div');
        cover.classList.add('cover-table');
        table[i].parentNode.insertBefore(cover, table[i]);
        cover.appendChild(table[i]);
    }
}
coverTable();

// Отримати всі елементи з класом "faq_elem"
const faqElements = document.querySelectorAll(".faq_elem");

// Перевірити кожен елемент та додати обробник події для кліку
faqElements.forEach((element) => {
    element.addEventListener("click", () => {
        // Додати клас "opening" до клікнутого елемента
        element.classList.toggle("opening");
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const header = document.querySelector('.list_header');
    const listContainer = document.querySelector('.anchore_menu');
    if (listContainer) {


    header.addEventListener('click', function () {
        listContainer.classList.toggle('open');
        header.classList.toggle('on_click');
    })};
});

// Script for chevrons in header and footer menus
function removeActive( index, selector ) {
    ChevronParent[index].querySelector( selector ).classList.remove( 'active' );
}

let ChevronParent = Array.from( document.querySelectorAll( 'li.menu-item-has-children' ) );
let index = 0;
if (ChevronParent.length !== 0) {
    for (let i = 0; i < ChevronParent.length; i++) {
        ChevronParent[i].insertAdjacentHTML( 'afterbegin', '<div class="chevron"></div>' );
        let сhevron = ChevronParent[i].querySelector( '.chevron' );

        сhevron.onclick = function () {
            if (i != index) {
                removeActive( index, '.chevron' );
                removeActive( index, 'ul.sub-menu' );
            }
            сhevron.classList.toggle( 'active' );
            ChevronParent[i].querySelector( 'ul.sub-menu' ).classList.toggle( 'active' );
            index = i;
        }

        document.addEventListener( 'click', ( e ) => {
            let withinBoundaries = e.composedPath().includes( ChevronParent[i] );

            if ( ! withinBoundaries) {
                removeActive( i, '.chevron' );
                removeActive( i, 'ul.sub-menu' );
            }
        } )
    }
}
